const body = document.body;

body.addEventListener("click", function (e) {
    if (e.target.classList.contains('cta-button') && !e.target.classList.contains('--unlogged') && !e.target.hasAttribute('data-ui-js-prevent')) {
        ctaButtonClick(e);
    }
});

function ctaButtonClick(e) {
    const element = e.target;
    const ajaxUrl = element.getAttribute('data-url') || element.getAttribute('href');

    if (ajaxUrl) {
        const options = {
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        e.preventDefault();
        fetch(ajaxUrl, options)
            .then(response => {
                if (!response.ok) throw new Error('Ajax call error: ' + response.status + '. (' + ajaxUrl + ')');
                return response.json();
            })
            .then(data => {
                setCtaButtonAttributes(element, data);
            })
            .catch(error => {
                console.error('ERROR: ' + error);
            });
    } else {
        // e.preventDefault();
    }
}

function setCtaButtonAttributes(element, data) {
    const activeClass = '--active';
    if (data.active) element.classList.add(activeClass);
    else if (element.classList.contains(activeClass)) element.classList.remove(activeClass);
    if ('url' in data) element.setAttribute('href', data.url);
    if ('messages' in data && data.messages.length > 0) {
        data.messages.forEach((message) => {
            flashMessageNotify({
                message_type: message.type,
                message: message.message,
                autohide: ('autohide' in message) ? message.autohide : false
            });
        });
    }
}
